import * as React from 'react';
import cx from 'classnames';
import * as style from './styles.css';
import { LandingBlock } from '../LandingBlock';
import { ContentWrapper } from '../ContentWrapper';
import { BlockHeader } from '../BlockHeader';

export const Steps = () => {
  return (
    <LandingBlock>
      <ContentWrapper>
        <BlockHeader>Как пользоваться Циан.Ипотекой?</BlockHeader>
        <div className={style['steps-container']}>
          <div className={style['step']}>
            <div className={style['step-count']}>1</div>
            <div className={style['step-content']}>
              <div className={style['step-image-block']}>
                <div className={cx(style['image'], style['step-one'])} />
              </div>
              <p className={style['step-description']}>
                Заполните анкету. Никаких сканов и справок: только паспортные данные и&nbsp;название&nbsp;работодателя
              </p>
            </div>
          </div>
          <div className={style['step']}>
            <div className={style['step-count']}>2</div>
            <div className={style['step-content']}>
              <div className={style['step-image-block']}>
                <div className={cx(style['image'], style['step-two'])} />
              </div>
              <p className={style['step-description']}>
                Вы получите предварительное решение от нескольких банков без каких-либо
                обязательств&nbsp;перед&nbsp;ними
              </p>
            </div>
          </div>
          <div className={style['step']}>
            <div className={style['step-count']}>3</div>
            <div className={style['step-content']}>
              <div className={style['step-image-block']}>
                <div className={cx(style['image'], style['step-three'])} />
              </div>
              <p className={style['step-description']}>
                Банки не будут с вами связываться, пока вы сами не закажете консультацию. В любой момент можно изменить
                анкету и отправить ещё раз
              </p>
            </div>
          </div>
        </div>
      </ContentWrapper>
    </LandingBlock>
  );
};
